module.exports = __webpack_public_path__ + "img/main-03-05-10books.e3acfa5d.png";